var MockAdapter = require("axios-mock-adapter");

export function doMock(axios) {
  var mock = new MockAdapter(axios);

  // 模拟栏目树数据
  mock.onGet("/channel/channelTree.do?sid=483").reply(200, `
  [
    {
        "template": "index.htm",
        "img": "",
        "pages": [],
        "name": "首页",
        "showPath": "/",
        "id": 22623,
        "linkOther": "/",
        "seo": {
            "seoDescription": "四川英识",
            "seoKeywords": "四川英识",
            "seoTitel": "首页"
        },
        "child": []
    },
    {
        "template": "about_us.htm",
        "img": "/upload/images/2023/01/29/3185c2ef52bd41ad875e1d66a75bd2ad.jpg",
        "pages": [],
        "name": "关于我们",
        "showPath": "/about/about_us",
        "id": 22624,
        "linkOther": "",
        "seo": {
            "seoDescription": "四川英识",
            "seoKeywords": "四川英识",
            "seoTitel": "关于我们"
        },
        "child": [
            {
                "template": "channel_content.htm",
                "img": "",
                "pages": [],
                "name": "公司简介",
                "showPath": "about_us#item01",
                "id": 22629,
                "seo": {
                    "seoDescription": "四川英识",
                    "seoKeywords": "四川英识",
                    "seoTitel": "公司简介"
                },
                "child": []
            },
            {
                "template": "channel_content.htm",
                "img": "",
                "pages": [],
                "name": "企业文化",
                "showPath": "about_us#item02",
                "id": 22630,
                "seo": {
                    "seoDescription": "四川英识",
                    "seoKeywords": "四川英识",
                    "seoTitel": "企业文化"
                },
                "child": []
            },
            {
                "template": "channel_content.htm",
                "img": "",
                "pages": [],
                "name": "资质证书",
                "showPath": "about_us#item03",
                "id": 22631,
                "seo": {
                    "seoDescription": "四川英识",
                    "seoKeywords": "四川英识",
                    "seoTitel": "资质证书"
                },
                "child": []
            },
            {
                "template": "channel_content.htm",
                "img": "",
                "pages": [],
                "name": "服务团队",
                "showPath": "about_us#item04",
                "id": 22632,
                "seo": {
                    "seoDescription": "四川英识",
                    "seoKeywords": "四川英识",
                    "seoTitel": "服务团队"
                },
                "child": []
            },
            {
                "template": "channel_content.htm",
                "img": "",
                "pages": [],
                "name": "检测设备",
                "showPath": "about_us#item05",
                "id": 22633,
                "seo": {
                    "seoDescription": "四川英识",
                    "seoKeywords": "四川英识",
                    "seoTitel": "检测设备"
                },
                "child": []
            }
        ]
    },
    {
        "template": "pro_list.htm",
        "img": "/upload/images/2023/01/29/394c6153bade4aaa8325d5332b501d5b.jpg",
        "pages": [],
        "name": "检测服务",
        "showPath": "/service/pro_list",
        "id": 22625,
        "linkOther": "",
        "seo": {
            "seoDescription": "四川英识",
            "seoKeywords": "四川英识",
            "seoTitel": "检测服务"
        },
        "child": [
            {
                "template": "pro_list.htm",
                "img": "",
                "pages": [],
                "name": "磁粉检测",
                "showPath": "pro_list?id=22634",
                "id": 22634,
                "seo": {
                    "seoDescription": "四川英识",
                    "seoKeywords": "四川英识",
                    "seoTitel": "磁粉检测"
                },
                "child": []
            },
            {
                "template": "pro_list.htm",
                "img": "",
                "pages": [],
                "name": "渗透检测",
                "showPath": "pro_list?id=22635",
                "id": 22635,
                "seo": {
                    "seoDescription": "四川英识",
                    "seoKeywords": "四川英识",
                    "seoTitel": "渗透检测"
                },
                "child": []
            },
            {
                "template": "pro_list.htm",
                "img": "",
                "pages": [],
                "name": "超声波测厚检测",
                "showPath": "pro_list?id=22636",
                "id": 22636,
                "seo": {
                    "seoDescription": "四川英识",
                    "seoKeywords": "四川英识",
                    "seoTitel": "超声波测厚检测"
                },
                "child": []
            },
            {
                "template": "pro_list.htm",
                "img": "",
                "pages": [],
                "name": "静水压试验",
                "showPath": "pro_list?id=22637",
                "id": 22637,
                "seo": {
                    "seoDescription": "四川英识",
                    "seoKeywords": "四川英识",
                    "seoTitel": "静水压试验"
                },
                "child": []
            }
        ]
    },
    {
        "template": "news_center.htm",
        "img": "/upload/images/2023/01/29/d8cf705fdb9b4c3495f4996e324cd664.jpg",
        "pages": [
            {
                "folder": "news",
                "showPath": "/news/news_detail",
                "id": 37,
                "title": "新闻详细"
            }
        ],
        "name": "新闻动态",
        "showPath": "/news/news_center",
        "id": 22626,
        "linkOther": "",
        "seo": {
            "seoDescription": "四川英识",
            "seoKeywords": "四川英识",
            "seoTitel": "新闻动态"
        },
        "child": []
    },
    {
        "template": "report.htm",
        "img": "/upload/images/2023/01/29/eba80d6ade254e459f2e42593f7dbb32.jpg",
        "pages": [],
        "name": "报告查询",
        "showPath": "/respone/respone-search",
        "id": 22627,
        "linkOther": "",
        "seo": {
            "seoDescription": "四川英识",
            "seoKeywords": "四川英识",
            "seoTitel": "报告查询"
        },
        "child": []
    },
    {
        "template": "recruitment.htm",
        "img": "/upload/images/2023/01/29/ab0c97acfb0943628d105204bd13f5a3.png",
        "pages": [],
        "name": "人才招聘",
        "showPath": "/job/job_center",
        "id": 22672,
        "linkOther": "",
        "seo": {
            "seoDescription": "四川英识",
            "seoKeywords": "四川英识",
            "seoTitel": "人才招聘"
        },
        "child": []
    },
    {
        "template": "contact_us.htm",
        "img": "/upload/images/2023/01/29/e177aa8c130149ea8035ed374d81ba22.jpg",
        "pages": [],
        "name": "联系我们",
        "showPath": "/contact/contact_us.htm",
        "id": 22628,
        "linkOther": "",
        "seo": {
            "seoDescription": "四川英识",
            "seoKeywords": "四川英识",
            "seoTitel": "联系我们"
        },
        "child": []
    }
]
  `);

  // 模拟页面数据
  mock.onGet(/\/channel\/channelInfo.do\?channelId=.*/).reply(200, 
      {
        img: '',
        name: '',
        seo: {
          seoDescription: '',
          seoKeywords: '',
          seoTitle: ''
        },
        channelData: '{"sections":[],"customStyle":"","customScript":""}'
      }
  );
}